module.exports = __webpack_public_path__ + "static/media/no_chart_image.5ff1f6f4.svg";